'use client';

import { usePathname } from 'next/navigation';

import type { TDynamicData } from '@eliadmin/core/src/api/dynamics/dynamics-api';
import type {
  CategoriesEntity,
  GeneralLayout,
  Menu,
} from '@eliadmin/core/src/api/general/types/general-layout-types';

import { DefaultHeader } from '@eliadmin/core/src/components/header/default-header';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { CartHeader } from '@eliadmin/core/src/components/header/cart-header';

export interface GenericHeaderProps {
  locale: string;
  generalLayout: GeneralLayout['data'];
  menu: Menu;
  categories: CategoriesEntity[];
  /** Položky topbaru z dynamickej sekcie. Košíková hlavička ich nerenderuje. */
  topbarItems?: TDynamicData[];
}

export function HeaderClient(props: GenericHeaderProps) {
  const pathname = usePathname();

  let isCart = false;
  try {
    isCart = pathname === ROUTES.CART();
  } catch {
    // page config may not be set yet during early SSR; default to non-cart header
  }

  if (isCart) {
    return <CartHeader {...props} />;
  }

  return <DefaultHeader {...props} />;
}
